import { render, staticRenderFns } from "./DataTableItemBasicStatus.vue?vue&type=template&id=76c7dfc7&"
import script from "./DataTableItemBasicStatus.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemBasicStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
